var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"btn",staticClass:"pull-right",class:[_vm.classObject, !_vm.$store.state.isHkom ? 'text-primary' : 'text-primary--green'],attrs:{"value":_vm.$t('vuePlUpload.defaultText'),"type":"button"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dce0a88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/VuePlupload.vue
// module id = null
// module chunks = 